import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { BreadcrumbService } from "../shared/breadcrumb.service";
import { PatientService } from "../../../services/patient.service";
import { Table } from "primeng/table";
import { past_medical_history_data } from "../../../models/history";
import { ApiResult, PromiseResult, ServerError } from "../../../models/PromiseResult";
import { HttpErrorResponse } from "@angular/common/http";
import { DateUtilService, moment_duration } from "../../../utilities/date.util.service";
import { MedicalReports } from "../../shared/patient-view/medical-reports/medical-reports.component";
import { UtilitiesService } from "src/app/utilities/utilities.service";
import { TraceClassDecorator } from "@sentry/angular";
import { health_passport_storage, health_passport_priority, healthPassportData } from 'src/app/models/patient-profile';
import { PaymentComponent } from '../../shared/payment/payment.component';
import { Router } from '@angular/router';
import { order_model, Payment_Data, PaymentSuccessResult } from 'src/app/models/basket';
import { ProviderStateService } from "src/app/services/provider-state.service";


interface file_Obj {
    file_id: number;
    document_link: string;
    document_key?: string;
    document_name: string;
    document_size: number;
    updated_at?: Date;
}
interface DocumentData {
    id: number;
    name: string;
    data: file_Obj[]
}

enum PAYMENT_FORMS_TABS {
    PACKAGE_FORM = 0,
    PAYMENT_FORMS = 1,
    PAYMENT_SUCCESS = 2,

}

@TraceClassDecorator()
@Component({
    selector: "app-viewhealth",
    templateUrl: "./viewhealth.component.html",
    styleUrls: ["./viewhealth.component.css"
        , '../../../../assets/css/custom-egd.css'
    ],
})
@TraceClassDecorator()
export class ViewhealthComponent implements OnInit {
    @ViewChild(PaymentComponent) payment_screen: PaymentComponent;
    //   selectMemeber: string = '';
    imagelist: any[] = [];
    imagelist_title: any[] = [];
    pdflist: any[] = [];
    pdflist_title: any[] = [];
    imageTitle: string;
    image: string = "";
    pdfTitle: string;
    pdf: string = "";
    slug: string = "";
    imageNo: number = 0;
    pdfNo: number = 0;
    selectMemeber = null;
    SelectedMemberName = "";
    member = "";
    value = "";
    textarea_data: any = [];
    members_data;
    doctor_reports;
    textarea;
    social_history;
    smoking;
    ext;
    alcohol;
    display1: boolean = false;
    smoking_type = null;
    imageview = ['https://images.pexels.com/photos/956981/milky-way-starry-sky-night-sky-star-956981.jpeg', 'https://images.all-free-download.com/images/graphiclarge/hd_picture_of_the_beautiful_natural_scenery_03_166249.jpg'];
    no_of_packs = "";
    is_changing: boolean = true;
    no_of_years_smoked = "";

    year_of_quitting_smoke = null;

    alcohol_type = null;

    drinks_per_week = "";

    year_of_quitting_alcohol = null;

    medical_history_count: number = 0;
    display: boolean = false;
    view_health_data = null;
    TZ: any = Intl.DateTimeFormat().resolvedOptions().timeZone;
    displayedColumns: string[] = [
        "RNo",
        "date",
        "opiniontype",
        "speciality",
        "doctorreport",
    ];
    displayedColumns1: string[] = ["condition", "yod", "status"];
    dateTime = new Date();
    health_passport_data: health_passport_storage = new health_passport_storage();
    health_passport_priority_data: health_passport_priority = new health_passport_priority();
    show_health_passport_bar: boolean = false;
    health_passport_amount;
    healthPassportData: healthPassportData = new healthPassportData(0, 2);
    // patientValue:string='member1';
    @ViewChild("dt") table: Table;
    @ViewChild("dt1") table1: Table;
    // constructor() { }
    posting: boolean;
    response: PromiseResult;
    serverError: ServerError;

    constructor(
        private readonly router: Router,
        private readonly breadcrumbService: BreadcrumbService,
        private readonly titleService: Title,
        private readonly patientservice: PatientService,
        private readonly dateUtil: DateUtilService,
        private readonly utilitiesService: UtilitiesService,
        private readonly changeDetector: ChangeDetectorRef,
        private readonly providerstateService: ProviderStateService
    ) {

        this.posting = false;
    }

    Document_data: DocumentData[] = [];

    members = [
        { name: "Mother", data: [] },
        { name: "Father", data: [] },
        { name: "Brother", data: [] },
        { name: "Sister", data: [] },
    ];
    medical_history: past_medical_history_data[] = [];
    allergy_list: any = [];
    medication_list = [];
    upload_records_data: boolean;
    medication_data;
    allergy_data;
    family_history_data;
    social_history_data;
    past_medical_history_data;
    c_data = [];
    condition_description = "";
    past_medical_surgical_history = "";
    MedicalReports: MedicalReports = new MedicalReports();

    ngOnInit(): void {
        this.slug = this.providerstateService.getProviderSlug();
        this.breadcrumbService.setItems([
            { label: "Dashboard", routerLink: ['/', this.slug, 'patient'] },
            { label: "Health Passport" },
        ]);
        this.response = {
            success: null,
            error: null,
            data: null
        }
        this.serverError = {
            statusCode: null,
            error: null,
            message: null
        }
        this.dateTime.setDate(this.dateTime.getDate());
        this.c_data = [];
        this.members_data = null;
        this.members_list = [];
        this.doctor_reports = [];
        this.upload_records_data = false;
        this.medication_data = " ";
        this.allergy_data = " ";
        this.family_history_data = " ";
        this.social_history_data = " ";
        this.past_medical_history_data = " ";
        this.condition_description = "";
        this.past_medical_surgical_history = "";;
        this.view_health_data = null;
        this.getMemberList();
        this.SetTitle("Dashboard - Health Passport");
    }
    member_result: any = [];
    members_list = [];
    condition_list: any = [];

    private async ResetResultModels(): Promise<void> {
        this.response = {
            success: null,
            error: null,
            data: null
        };
        this.serverError = {
            statusCode: null,
            error: null,
            message: null
        }
    }

    async getMemberList() {
        let temp = [];
        await this.ResetResultModels();
        this.posting = true;
        await this.patientservice
            .getMember(sessionStorage.getItem("userid"))
            .toPromise()
            .then((result) => {
                if (result.success) {
                    for (let i = 0; i < result.data.patient.length; i++) {

                        temp.push({
                            label:
                                " " +
                                result.data.patient[i].first_name +
                                " " +
                                (result.data.patient[i].middle_name == null ? '' : result.data.patient[i].middle_name) +
                                " " +
                                result.data.patient[i].last_name +
                                " ",
                            value: result.data.patient[i].patient_guid,
                        });
                    }
                }
                else {
                    this.response = result;
                }
                this.posting = false;

            }).catch((error: HttpErrorResponse) => {
                this.serverError = error.error;
                this.response.success = false;
                this.posting = false;
            });
        this.members_list = temp;
        await this.getHealthPassportStorage(this.member);
        await this.getHealthPassportPriority(this.member);

    }

    async GetPersonalDetails(memeberdetails) {
        // await this.patientservice.GetPersonalData(this.member).toPromise().then(result => {

        let temp;
        if (this.view_health_data.success) {
            const dage = this.dateUtil.diff(memeberdetails.date_of_birth, new Date(), moment_duration.years)
            const age = dage + " Yrs";
            temp = {
                id_guid: this.member, member: memeberdetails.first_name + ' ' +
                    memeberdetails.last_name, DOB: memeberdetails.date_of_birth,
                age: age,
                gender: memeberdetails.gender,
                user_profile_pic: memeberdetails.avatar_url,
                user_identification_type: memeberdetails.identification_type,
                user_identification_pic: memeberdetails.identification_url,
                medical_record_number: memeberdetails.medical_record_number
            };
            this.members_data = temp;

        }
        // });
    }

    showviewall() {
        this.display = true;
    }
    async yearsDiff(d1, d2) {
        let date1 = new Date(d1);
        let date2 = new Date(d2);
        let yearsDiff = date2.getFullYear() - date1.getFullYear();
        return yearsDiff;
    }

    downloadPdf(pdfUrl: string, pdfName: string) {
        // FileSaver.saveAs(pdfUrl, pdfName);
    }
    async preprocess_familyhistory(raw_familyhistory: any[]) {
        for (const member of this.members) {
            for (const raw_member of raw_familyhistory) {
                if (member.name == raw_member.name) {
                    const temp = [];
                    for (const hist of raw_member.data) temp.push(
                        {
                            "name": hist
                        }
                    )
                    member.data = temp;
                }
            }
        }

    }

    async getHealthPassportStorage(patient_guid: string) {
        this.healthPassportData.create_passport.patient_guid = patient_guid;
        await this.patientservice.getHealthPassportStorage(patient_guid)
            .toPromise()
            .then(result => {
                if (result.success) {
                    this.health_passport_data = result.data.storageDetails;
                }
            })
            .catch((error: HttpErrorResponse) => {

            })
    }
    async getHealthPassportPriority(patient_guid: string) {
        await this.patientservice.getHealthPassportPriority(patient_guid)
            .toPromise()
            .then(result => {
                if (result.success) {
                    this.health_passport_priority_data = result.data;
                    this.health_passport_priority_data.consultation_name = result.data.consultation_name;
                    this.health_passport_priority_data.amount = result.data.amount;
                    this.health_passport_priority_data.country.currency_type = result.data.country.currency_type;
                    this.health_passport_priority_data.description = result.data.description;
                    this.health_passport_amount = this.renderAmount(result.data.amount, result.data.country.currency_type);
                    this.healthPassportData.create_passport.priority_type_id = result.data.id;
                }
            })
            .catch((error: HttpErrorResponse) => {

            })
    }

    BuyHealthPassport() {

    }
    renderAmount(amount: number | string, currency_type: string) {
        return this.utilitiesService.getRenderedAmount(Number(amount), currency_type);
    }
    async GetTextareaData() {
        this.c_data = [];
        this.medication_data = "";
        this.allergy_data = "";
        this.family_history_data = "";
        this.social_history_data = "";
        this.past_medical_history_data = "";
        this.condition_description = "";
        this.image = "";
        this.Document_data = [];


        if (this.view_health_data.data.condtion != null) {
            if (this.view_health_data.success && this.view_health_data.data.condtion.current_medical_problems.length > 0) {
                let data = this.view_health_data.data.condtion.current_medical_problems;
                this.condition_description = data;
            }
        }

        if (this.view_health_data.data.condtion == null) {
            this.condition_description = "N/A";
        }

        if (Object.keys(this.view_health_data.data.documents).length > 0) {
            let fileobj = this.view_health_data.data.documents;

            for (const key of Object.keys(fileobj)) {
                if (fileobj.hasOwnProperty(key)) {
                    if (fileobj[key].length > 0) {
                        this.Document_data.push({
                            id: this.Document_data.length,
                            name: key.replace(/_/g, " ").toUpperCase(),
                            data: fileobj[key],
                        });
                    }
                }

            }
            this.pdflist = [];
            this.pdflist_title = [];
            this.imagelist = [];
            this.imagelist_title = [];
            for (let i = 0; i < this.Document_data.length; i++) {
                if (this.Document_data[i].data.length > 0) {
                    for (let j = 0; j < this.Document_data[i].data.length; j++) {
                        if (this.Document_data[i].data[j].document_name.split('.').slice(-1)[0] == "pdf") {

                            this.pdflist.push(encodeURI(this.Document_data[i].data[j].document_link))
                            this.pdflist_title.push(this.Document_data[i].name)
                            this.pdf = this.pdflist[0];
                            this.pdfTitle = this.pdflist_title[0];

                        }
                        else {

                            this.imagelist.push(encodeURI(this.Document_data[i].data[j].document_link))
                            this.imagelist_title.push(this.Document_data[i].name)
                            this.image = this.imagelist[0];
                            this.imageTitle = this.imagelist_title[0];

                        }
                    }
                }
            }





        }




        if (this.view_health_data.data.history != null) {
            if (this.view_health_data.success) {

                if (this.view_health_data.data.history.family_history.length > 0) {

                    //this.members = this.view_health_data.data.history.family_history;
                    this.preprocess_familyhistory(this.view_health_data.data.history.family_history)
                }

                if (this.view_health_data.data.history.past_medical_history_data.length > 0) {

                    this.medical_history = this.view_health_data.data.history.past_medical_history_data;
                }
                if (this.view_health_data.data.history.social_history.length > 0) {
                    this.social_history = this.view_health_data.data.history.social_history;
                    this.alcohol = this.social_history.alcohol;
                    this.smoking = this.social_history.smoking;
                }

                this.past_medical_history_data = "";
                if (this.medical_history.length == 0) {
                    this.past_medical_history_data = "N/A";
                }
                for (let j = 0; j < this.medical_history.length; j++) {
                    if (j == 0 && j == this.medical_history.length - 1) {
                        this.past_medical_history_data += this.medical_history[j].name + ". \n";
                    }
                    else if (j == 0) {
                        this.past_medical_history_data += this.medical_history[j].name;
                    }
                    else if (j == this.medical_history.length - 1) {
                        this.past_medical_history_data += ", " + this.medical_history[j].name + ". \n";
                    }
                    else
                        this.past_medical_history_data += ", " + this.medical_history[j].name;

                }

                this.family_history_data = "";
                for (let i = 0; i < this.members.length; i++) {

                    if (this.members[i].data.length > 0) {



                        this.family_history_data += this.members[i].name;
                        for (let j = 0; j < this.members[i].data.length; j++) {

                            if (j == 0 && j == this.members[i].data.length - 1) {
                                this.family_history_data += " : " + this.members[i].data[j].name + ". \n";
                            }
                            else if (j == 0) {
                                this.family_history_data += " : " + this.members[i].data[j].name;
                            }
                            else if (j == this.members[i].data.length - 1) {
                                this.family_history_data += ", " + this.members[i].data[j].name + ". \n";
                            }
                            else
                                this.family_history_data += ", " + this.members[i].data[j].name;

                        }

                    }
                }
                if (this.family_history_data.length == 0) this.family_history_data = "N/A";

                if (this.view_health_data.data.history.past_surgical_history_data.length > 0) {
                    this.past_medical_surgical_history = this.view_health_data.data.history.past_surgical_history_data;
                }
                this.social_history_data = "";

                if (this.view_health_data.data.history.social_history != null) {
                    this.alcohol = this.view_health_data.data.history.social_history.alcohol;
                    this.smoking = this.view_health_data.data.history.social_history.smoking;
                    this.smoking_type = this.smoking.selected;
                    this.alcohol_type = this.alcohol.selected;
                    if (this.smoking_type == "Yes") {
                        this.no_of_packs = this.smoking.data.number_of_packs_per_day;
                        this.no_of_years_smoked = this.smoking.data.numbers_of_years_smoked;
                        this.year_of_quitting_smoke = null;
                        this.social_history_data += "Smoking :" + this.smoking_type + "\n" + " Number of Packs :" + this.no_of_packs + "\n Number of Years :" + this.no_of_years_smoked + "\n";
                    }
                    else if (this.smoking_type == "Not Currently") {
                        this.no_of_packs = "";
                        this.no_of_years_smoked = "";
                        this.year_of_quitting_smoke = { name: this.smoking.data.year_of_quitting };
                        this.social_history_data += "Smoking :" + this.smoking_type + "\n" + " Year of Quitting :" + this.year_of_quitting_smoke.name + "\n";

                    }
                    else if (this.smoking_type == "Never") {
                        this.no_of_packs = "";
                        this.no_of_years_smoked = "";
                        this.year_of_quitting_smoke = null;
                        this.social_history_data += "Smoking :" + this.smoking_type + "\n";

                    }
                    this.social_history_data += "\n";
                    if (this.alcohol_type == "Yes") {
                        this.drinks_per_week = this.alcohol.data.drinks_per_week;
                        this.year_of_quitting_alcohol = null;
                        this.social_history_data += "Alcohol :" + this.alcohol_type + " \n Drinks per week :" + this.drinks_per_week + "\n";

                    }
                    else if (this.alcohol_type == "Not Currently") {
                        this.drinks_per_week = "";
                        this.year_of_quitting_alcohol = { name: this.alcohol.data.year_of_quitting };
                        this.social_history_data += "Alcohol :" + this.alcohol_type + "\n Year of Quitting :" + this.year_of_quitting_alcohol.name + "\n";
                    }
                    else if (this.alcohol_type == "Never") {
                        this.drinks_per_week = "";
                        this.year_of_quitting_alcohol = null;
                        this.social_history_data += "Alcohol :" + this.alcohol_type + "\n";
                    }
                    // this.social_history_data.replace("\n", "<br>");
                }



            }
            if (this.view_health_data.data.history.social_history == null) {
                this.social_history_data = "N/A";
            }
            if (this.view_health_data.data.history.past_medical_history_data == null) {
                this.past_medical_history_data = "N/A";
            }
            if (this.view_health_data.data.history.family_history == null) {
                this.family_history_data = "N/A";
            }
            if (this.view_health_data.data.history.past_surgical_history_data == null) {
                this.past_medical_surgical_history = "N/A";
            }


            if (this.view_health_data.data.history.social_history.length == 0) {
                this.social_history_data = "N/A";
            }
            if (this.view_health_data.data.history.past_medical_history_data.length == 0) {
                this.past_medical_history_data = "N/A";
            }
            if (this.view_health_data.data.history.family_history.length == 0) {
                this.family_history_data = "N/A";
            }
            if (this.view_health_data.data.history.past_surgical_history_data.length == 0) {
                this.past_medical_surgical_history = "N/A";
            }
        }



        if (this.view_health_data.data.allergies_medications != null) {
            if (this.view_health_data.success) {

                this.medication_list = this.view_health_data.data.allergies_medications.medications_allergies_data.medications;
                this.medication_data = "";

                if (this.medication_list.length > 0) {
                    this.medication_data += ""
                    for (let j = 0; j < this.medication_list.length; j++) {


                        let times_per_day = this.medication_list[j].times_per_day.trim().length > 0 ? this.medication_list[j].times_per_day : "N/A";
                        if (!Boolean(this.medication_list[j]['instructions'])) {
                            this.medication_list[j]['instructions'] = "";
                        }
                        let instructions = this.medication_list[j].instructions.trim().length > 0 ? this.medication_list[j].instructions : "N/A";
                        this.medication_data += "Medication Name : " + this.medication_list[j].name + "    Dose : " + this.medication_list[j].dose + "    Times Per Day : " + times_per_day + "    Instructions : " + instructions + " . \n";
                    }
                }


            }

            if (this.view_health_data.data.allergies_medications.medications_allergies_data.allergies.length == 0 && this.view_health_data.data.allergies_medications.medications_allergies_data.medications.length == 0) {
                this.medication_data = "N/A";
            }
        }

        if (this.view_health_data.data.allergies_medications != null) {
            if (this.view_health_data.success) {
                this.allergy_list = this.view_health_data.data.allergies_medications.medications_allergies_data.allergies;
                this.allergy_data = "";
                if (this.allergy_list.length > 0) {
                    this.allergy_data += "";
                    for (let j = 0; j < this.allergy_list.length; j++) {

                        this.allergy_data += "Allergy Name : " + this.allergy_list[j].name + "    Allergic Reaction : " + this.allergy_list[j].reaction + " . \n";

                    }
                }
            }
            if (this.view_health_data.data.allergies_medications.medications_allergies_data.allergies == null && this.view_health_data.data.allergies_medications.medications_allergies_data.medications == null) {
                this.allergy_data = "N/A";
            }
        }




        if (this.condition_description.length == 0) {
            this.condition_description = "N/A";
        }
        if (this.past_medical_history_data.length == 0) {
            this.past_medical_history_data = "N/A";
        }
        if (this.past_medical_surgical_history.length == 0) {
            this.past_medical_surgical_history = "N/A";
        }
        if (this.family_history_data.length == 0) {
            this.family_history_data = "N/A";
        }
        if (this.social_history_data.length == 0) {
            this.social_history_data = "N/A";
        }
        if (this.medication_data.length == 0) {
            this.medication_data = "N/A";
        }
        if (this.allergy_data.length == 0) {
            this.allergy_data = "N/A";
        }
        this.c_data.push({ id_guid: this.member, condition_description: this.condition_description, past_medical_history: this.past_medical_history_data, past_surgical_history: this.past_medical_surgical_history, family_history: this.family_history_data, social_history: this.social_history_data, medication: this.medication_data, allergy: this.allergy_data, ur: this.upload_records_data });
        this.textarea = this.c_data;

    }

    // openDoc(pdfUrl: string) {
    //     window.open(pdfUrl + "#page=" + 1, "_blank", "", true);
    // }
    onNext() {
        if (this.imageNo < this.imagelist.length - 1) {
            this.imageNo++;
            this.imageTitle = this.imagelist_title[this.imageNo];
            this.image = this.imagelist[this.imageNo];
        }


    }

    onPrevious() {
        if (this.imageNo > 0) {
            this.imageNo--;
            this.imageTitle = this.imagelist_title[this.imageNo];
            this.image = this.imagelist[this.imageNo];
        }

    }

    onNext1() {
        if (this.pdfNo < this.pdflist.length - 1) {
            this.pdfNo++;
            this.pdfTitle = this.pdflist_title[this.pdfNo];
            this.pdf = this.pdflist[this.pdfNo];
        }

    }

    onPrevious1() {
        if (this.pdfNo > 0) {
            this.pdfNo--;
            this.pdfTitle = this.pdflist_title[this.pdfNo];
            this.pdf = this.pdflist[this.pdfNo];
        }

    }

    shallow_copy(a) {
        return this.utilitiesService.shallow_copy(a);
    }

    private async GetHealthData(patient_guid: string): Promise<void> {
        await this.ResetResultModels();
        this.posting = true;
        this.MedicalReports.data.api_result.Posting = true;
        await this.patientservice.GetHealthSummary(patient_guid)
            .toPromise().then(async result => {
                let a: PromiseResult = result;
                if (result.success) {
                    this.view_health_data = this.shallow_copy(result);
                    a.data = this.shallow_copy(a.data.documents);
                    await this.GetPersonalDetails(this.view_health_data.data.patient)
                    await this.GetTextareaData();
                }
                else {
                    this.response = result;
                    a.data = {};
                }
                this.MedicalReports.data.api_result.PromiseResult = a;
                this.MedicalReports.data.api_result.Posting = false;
                this.posting = false;
            }).catch((error: HttpErrorResponse) => {
                this.serverError = error.error;
                this.response.success = false;
                this.posting = false;
                this.MedicalReports.data.api_result.ServerError = error.error;
                this.MedicalReports.data.api_result.Posting = false;
                this.MedicalReports.data.api_result.PromiseResult.success = false;
            });
    }


    async onChange() {

        this.is_changing = true;
        this.view_health_data = null;
        this.member = this.selectMemeber.value;
        this.SelectedMemberName = this.selectMemeber.label;
        this.c_data = [];
        this.doctor_reports = [];
        this.medication_data = " ";
        this.allergy_data = " ";
        this.family_history_data = " ";
        this.social_history_data = " ";
        this.past_medical_history_data = " ";
        this.smoking;
        this.alcohol;
        this.smoking_type = null;
        this.no_of_packs = "";
        this.no_of_years_smoked = "";
        this.year_of_quitting_smoke = null;
        this.alcohol_type = null;
        this.drinks_per_week = "";
        this.year_of_quitting_alcohol = null;
        this.imagelist = [];
        this.pdflist = [];
        this.imagelist_title = [];
        this.pdflist_title = [];
        this.imageNo = 0;
        this.image = "";
        this.pdf = "";

        this.members_data = null;
        this.condition_description = "";
        this.past_medical_surgical_history = "";
        await this.GetHealthData(this.member);
        await this.getHealthPassportStorage(this.member);
        await this.getHealthPassportPriority(this.member);
        this.is_changing = false;
        //this.GetPersonalDetails();
        //this.GetTextareaData();
    }
    Reload() {
        window.location.reload();


    }
    displayfile() {
        this.display1 = true;
    }
    SetTitle(title: string) {
        //   let Title = this.titleService.getTitle().split(" ");
        //   let notif = Title[0].substr(1, Title[0].length - 2);
        //   this.titleService.setTitle("(" + String(notif) + ") " + title);
        this.titleService.setTitle(title);
    }

    async submitHealthPassport() {
        this.healthPassportData.health_passport_submit_api_result = new ApiResult(true);
        this.healthPassportData.paymentData.payment_start_api_result = new ApiResult(true);
        this.healthPassportData.paymentData = new Payment_Data();
        await this.patientservice
            .createHealthPassport(this.healthPassportData.create_passport)
            .toPromise()
            .then(async (result) => {
                this.healthPassportData.health_passport_submit_api_result.PromiseResult = result;
                this.healthPassportData.paymentData.payment_start_api_result.PromiseResult = result;
                console.log(result,"hello");
                if (result.success) {

                    this.healthPassportData.paymentData.stripe_checkout_url = result.data.stripe_checkout_url;
                    console.log(this.healthPassportData.paymentData.stripe_checkout_url, "checking");
                    await this.start_payment();
                }
                // else {
                //     this.healthPassportData.paymentData.payment_start_api_result.ErrorModel=result.error
                // }
                this.healthPassportData.paymentData.payment_start_api_result.Posting = false
                this.healthPassportData.health_passport_submit_api_result.Posting = false;
            }).catch((error) => {
                this.healthPassportData.health_passport_submit_api_result.ServerError = error.error;
                console.error(error,"checking for error");
                this.healthPassportData.health_passport_submit_api_result.PromiseResult.success = false;
                this.healthPassportData.health_passport_submit_api_result.Posting = false;
                this.healthPassportData.paymentData.payment_start_api_result.ServerError = error.error;
                this.healthPassportData.paymentData.payment_start_api_result.PromiseResult.success = false;
                this.healthPassportData.paymentData.payment_start_api_result.Posting = false;
            });
    }
    async openInvoice() {
        this.healthPassportData.print_data.api_result = new ApiResult(true)
        this.healthPassportData.print_data.displayModal = true;
        await this.patientservice
            .fetchInvoice(this.healthPassportData.paymentData.paymentSuccessData.consultationData.transaction_id)
            .toPromise()
            .then((result) => {
                this.healthPassportData.print_data.api_result.PromiseResult = result;
                if (result.success) {
                    this.healthPassportData.print_data.data = result.data;
                }
                else {
                    this.healthPassportData.print_data.api_result.ErrorModel = result.error;
                }
                this.healthPassportData.print_data.api_result.Posting = false;
            }).catch((error: HttpErrorResponse) => {
                this.healthPassportData.print_data.api_result.ServerError = error.error;
                this.healthPassportData.print_data.api_result.PromiseResult.success = false;
                this.healthPassportData.print_data.api_result.Posting = false;
            });
    }


    async start_payment() {
        this.changeDetector.detectChanges();
        console.log("loading payment gateway");
        await this.payment_screen.load_payment_gateway();
    }

    onPaymentSuccess(data: PaymentSuccessResult) {
        this.healthPassportData.paymentData.paymentSuccessData = data;
        this.healthPassportData.tabview_Data.nextTab();
    }

    async nextTab() {
        switch (this.healthPassportData.tabview_Data.selected_tab) {
            case PAYMENT_FORMS_TABS.PACKAGE_FORM:
                await this.submitHealthPassport();
                this.healthPassportData.tabview_Data.nextTab();
                break;
            default:
                break;
        }
    }

    async prevTab() {
        this.healthPassportData.tabview_Data.prevTab();
    }

    RouterNavigation(path: string) {
        this.router.navigate(['/' + this.slug + '/patient/' + path]);
    }

    reload() {
        window.location.reload()
    }

    print() {
        window.print();
    }

    isPosting(): boolean {
        return this.healthPassportData.health_passport_list_api_result.Posting ||
            this.healthPassportData.health_passport_submit_api_result.Posting;
    }
}
